import {
  PLUGIN_DELETE_INSTALLED_PLUGIN_BEGIN,
  PLUGIN_DELETE_INSTALLED_PLUGIN_SUCCESS,
  PLUGIN_DELETE_INSTALLED_PLUGIN_FAILURE,
  PLUGIN_DELETE_INSTALLED_PLUGIN_DISMISS_ERROR,
} from './constants';

import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function deleteInstalledPlugin(args = {}) {
  return (dispatch) => {
    dispatch({
      type: PLUGIN_DELETE_INSTALLED_PLUGIN_BEGIN,
    });
    const { projectId, version, installedPluginId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/plugins/${installedPluginId}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: PLUGIN_DELETE_INSTALLED_PLUGIN_SUCCESS,
            data: res.data,
          });
          Mixpanel.track('Uninstalled Plugin');
          toast.success('Uninstalled Successfully !', {});
          resolve(res);
        },
        (err) => {
          dispatch({
            type: PLUGIN_DELETE_INSTALLED_PLUGIN_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to uninstall plugin');
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Failed: ${errMsg}` || 'Uninstallation Failed !');
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteInstalledPluginError() {
  return {
    type: PLUGIN_DELETE_INSTALLED_PLUGIN_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PLUGIN_DELETE_INSTALLED_PLUGIN_BEGIN:
      return {
        ...state,
        deleteInstalledPluginPending: true,
        deleteInstalledPluginError: null,
      };

    case PLUGIN_DELETE_INSTALLED_PLUGIN_SUCCESS:
      return {
        ...state,
        deleteInstalledPluginPending: false,
        deleteInstalledPluginError: null,
        installedPlugins: action.data ? action.data : [],
      };

    case PLUGIN_DELETE_INSTALLED_PLUGIN_FAILURE:
      return {
        ...state,
        deleteInstalledPluginPending: false,
        deleteInstalledPluginError: action.data.error,
      };

    case PLUGIN_DELETE_INSTALLED_PLUGIN_DISMISS_ERROR:
      return {
        ...state,
        deleteInstalledPluginError: null,
      };

    default:
      return state;
  }
}
